var render = function () {
  var _vm$remarkObj, _vm$remarkObj2, _vm$remarkObj$text, _vm$remarkObj3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.remark ? _c('BBadge', {
    staticClass: "badge-remark px-75",
    attrs: {
      "variant": (_vm$remarkObj = _vm.remarkObj) !== null && _vm$remarkObj !== void 0 && _vm$remarkObj.variant ? "light-".concat((_vm$remarkObj2 = _vm.remarkObj) === null || _vm$remarkObj2 === void 0 ? void 0 : _vm$remarkObj2.variant) : 'light-secondary',
      "pill": ""
    }
  }, [_vm._v(" " + _vm._s((_vm$remarkObj$text = (_vm$remarkObj3 = _vm.remarkObj) === null || _vm$remarkObj3 === void 0 ? void 0 : _vm$remarkObj3.text) !== null && _vm$remarkObj$text !== void 0 ? _vm$remarkObj$text : _vm.remark) + " ")]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }